@if (sidebarService.sections$ | async; as sidebarSections) {
  @if (breakpointService.deviceSize$ | async; as deviceSize) {
    <div
      tabindex="0"
      aria-expanded="false"
      class="sidebar"
      [ngClass]="{
        mobile: deviceSize.isMobile,
        'mobile-open': deviceSize.isMobile && sidebarService.forceExpand,
        'single-section': sidebarSections.length === 1,
        'multi-section': sidebarSections.length > 1,
      }"
    >
      <div class="sidebar-internal" tabindex="0" aria-expanded="false">
        @for (sidebarSection of mobileSizeMenu(sidebarSections, deviceSize.isMobile); track sidebarSection.title) {
          <mat-accordion>
            <mat-expansion-panel
              hideToggle
              id="sidebar-expansion-panel"
              [(expanded)]="sidebarSection.expanded"
              (opened)="expandSection(sidebarSection, sidebarSections)"
              (closed)="sidebarSection.expanded = false"
            >
              @if (sidebarSections.length > 1) {
                <mat-expansion-panel-header [ngClass]="{ 'selected-header': sidebarSection === chosenSection }">
                  <p id="sidebar-section-header">
                    <label for="">
                      <img
                        [alt]="sidebarSection.expanded ? 'Close Section' : 'Open Section'"
                        [src]="icon(sidebarSection)"
                      />
                      <span id="sidebar-section-title" class="flex-grow-1 fc-white">{{ sidebarSection.title }}</span>
                    </label>
                    @if (sidebarSection.expanded) {
                      <img
                        id="close-button"
                        class="dropdown-button"
                        src="assets/glyphs/sidebar/dropdown_close.svg"
                        alt="Close button"
                        height="8"
                        width="8"
                      />
                    } @else {
                      <img
                        id="open-button"
                        class="dropdown-button"
                        src="assets/glyphs/sidebar/dropdown_open.svg"
                        alt="Open button"
                        height="8"
                        width="8"
                      />
                    }
                  </p>
                </mat-expansion-panel-header>
              }
              <ng-template matExpansionPanelContent>
                <div class="sidebar-section">
                  @for (sidebarItem of sidebarSection.items; track sidebarItem.title) {
                    @if (sidebarItem.sidebarSubItem?.length || 0 > 0) {
                      <div
                        id="sidebar-section-item"
                        class="w-100 fc-white"
                        [ngClass]="{ 'py-0 my-0 d-block': isSubItemsVisible }"
                        (mouseenter)="showSubItem(sidebarItem.sidebarSubItem)"
                        (mouseleave)="onLeave()"
                      >
                        <span
                          class="subItem-section-item-text fc-white"
                          tabindex="0"
                          [ngClass]="{ 'subItem_bg_text my-0 ': isSubItemsVisible }"
                          [attr.aria-expanded]="isSubItemsVisible"
                        >
                          {{ sidebarItem.title }}
                          <img
                            id="open-button"
                            class="dropdown-button"
                            src="assets/glyphs/sidebar/dropdown_open.svg"
                            alt="Open button"
                            height="8"
                            width="8"
                          />
                        </span>
                      </div>
                      @if (deviceSize.isMobile) {
                        <div (mouseenter)="showSubItem()" (mouseleave)="onLeave()">
                          @if (isSubItemsVisible) {
                            <div class="sidebar-subItem-container">
                              <div class="sidebar-subItem-container-item-wrap">
                                @if (sidebarService.sections$ | async; as sidebarService) {
                                  @for (subItem of sidebarItem.sidebarSubItem; track subItem) {
                                    <div class="sidebar-subItem-container-item">
                                      <a [routerLink]="subItem.routerLink() || null">
                                        <span class="f-12 fc-white">{{ subItem.title }}</span>
                                      </a>
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }
                    } @else {
                      <div
                        id="sidebar-section-item"
                        class="sidebar-section-item"
                        [ngClass]="{
                          selected: checkSidebarItem(sidebarItem),
                          locked: featureFlagService.marketPlaceLocked && sidebarItem.locked,
                        }"
                        (click)="setChosenSection(sidebarSection, sidebarItem)"
                      >
                        <a
                          [tabindex]="featureFlagService.marketPlaceLocked && sidebarItem.locked ? -1 : 0"
                          [routerLink]="
                            featureFlagService.marketPlaceLocked && sidebarItem.locked
                              ? null
                              : sidebarItem.routerLink() || null
                          "
                          [attr.aria-disabled]="featureFlagService.marketPlaceLocked && sidebarItem.locked"
                        >
                          <span class="icon-container">
                            @if (sidebarSections.length === 1) {
                              <img
                                [alt]="sidebarItem.title"
                                [src]="sidebarItem.icon"
                                [class]="sidebarItem.iconClass"
                                [matTooltip]="sidebarItem.toolTip"
                                [matTooltipDisabled]="!sidebarItem.toolTip"
                              />
                            }

                            @if (featureFlagService.marketPlaceLocked && sidebarItem.locked) {
                              <img
                                id="marketplace-locked-icon-overlay"
                                src="assets/marketplace/claim-lock.svg"
                                alt="Marketplace locked"
                                class="claim-locked-icon-overlay"
                                [matTooltip]="
                                  (sidebarItem.title | lowercase).includes('prime')
                                    ? 'Prudent prime isn\'t open yet- complete your enrolment to start exploring!'
                                    : 'Marketplace isn\'t open yet- complete your enrolment to start exploring!'
                                "
                              />
                            }
                          </span>
                          <span id="sidebar-section-item-text" class="fc-white">{{ sidebarItem.title }} </span>

                          @if (sidebarItem.showExternalLink) {
                            <img
                              alt="External Navigation Icon"
                              class="float-right"
                              src="assets/glyphs/black/share.svg"
                              id="sidebar-section-item-external-link"
                            />
                          }
                        </a>
                      </div>
                    }
                  }
                </div>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
      @if (!deviceSize.isMobile) {
        <div tabindex="0" aria-expanded="false" (mouseenter)="showSubItem()" (mouseleave)="onLeaveSidebar()">
          @if (isSubItemsVisible) {
            <div class="sidebar-subItem-container" tabindex="0" aria-expanded="false">
              @for (subItem of subItems; track subItem) {
                <div class="sidebar-subItem-container-item" tabindex="0" aria-expanded="false">
                  <a [routerLink]="subItem.routerLink() || null">
                    <span class="f-12 fc-white">{{ subItem.title }}</span>
                  </a>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
}
